<template>
    <main class="mt-5">
        <div class="card mt-3">
            <div class="card-header border-0">
                <h5 class="card-title font-bold py-3">جزئیات حواله</h5>
                <div style="flex: 1"></div>
                <Back url="/admin/havale" />
            </div>
            <div class="row col-12 mr-2">
                <div class="col-4">
                    <span>شناسه حواله: </span>
                    <span class="font-weight-bold">{{ havale.id }}</span>
                </div>
                <div class="col-4">
                    <span>انبار مبدا: </span>
                    <span class="font-weight-bold">{{ havale.from_store_label }}</span>
                </div>
                <div class="col-4">
                    <span>انبار مقصد: </span>
                    <span class="font-weight-bold">{{ havale.to_store_label }}</span>
                </div>
            </div>
            <div class="row col-12 mr-2 mt-3">
                <div class="col-4">
                    <span>فروشنده: </span>
                    <span class="font-weight-bold">{{ havale.transmitter_full_name }}</span>
                </div>
                <div class="col-4">
                    <span>زمان ثبت: </span>
                    <span class="font-weight-bold">{{ havale.created_at | persianDate }}</span>
                </div>
            </div>
        </div>
        <div class="card mt-3">
            <div class="card-header border-0">
                <h5 class="card-title font-bold py-3">آیتم های حواله</h5>
                <div style="flex: 1"></div>
            </div>
            <div class="p-5">
                <b-table
                    id="main-table"
                    bordered
                    striped
                    :fields="fields"
                    :items="items"
                    responsive="sm"
                    >
                    <template #cell(index)="data">
                        {{ data.index + 1 }}
                    </template>
                </b-table>
            </div>
        </div>
    </main>
</template>
<script>
    import {
        BTable,
        BFormGroup,
        BFormInput,
        BTr,
        BTd,
        BButton,
        BModal,
    } from "bootstrap-vue";
    import DatePickerRange from "@@/core/components/shared/DatePickerRange/DatePickerRange";
    import ShowVarietiesModal from "@@/core/components/report/ShowVarietiesModal";
    import configProvider from "@@/core/configProvider";
    import Back from "@@/core/components/shared/Back/Back";

    export default {
    name: "HavaleShow",
    components: {
        ShowVarietiesModal,
        DatePickerRange,
        BTable,
        BFormGroup,
        BFormInput,
        Back,
        BTr,
        BTd,
        BButton,
        BModal,
    },
    configProvider,
    data() {
        return {
            havale: [],
            items: [],
            index: 1,
            fields: [
                {
                    key: "index",
                    label: "ردیف",
                },
                {
                    key: "variety_title",
                    label: "محصول",
                },
                {
                    key: "quantity",
                    label: "تعداد انتقال",
                },
            ],
            id: this.$route.params.id,
        };
    },
    mounted() {
        this.loadData();
    },
    methods: {
        async loadData(){
        try {
            const response = await this.$axios.get("admin/store_transfers/" + this.id);
            this.havale = response.data.data.transfer;
            this.items = response.data.data.items;
            console.log(this.havale);
        } catch (e) {
            this.$root.notify(e);
        }
        },
    },
};
</script>
<style>
</style>
